import { api } from '../api';

const unwrap = (r) => r.data?.data ?? r.data;

export default {
  /* ── test drives ── */
  list: (params) => api.get('/v1/test-drives', { params }).then(unwrap),
  get: (id) => api.get(`/v1/test-drives/${id}`).then(unwrap),
  create: (body) => api.post('/v1/test-drives', body).then(unwrap),
  update: (id, body) => api.patch(`/v1/test-drives/${id}`, body).then(unwrap),
  start: (id, body) => api.post(`/v1/test-drives/${id}/start`, body).then(unwrap),    // {kmOut, tradePlateId}
  complete: (id, body) => api.post(`/v1/test-drives/${id}/complete`, body).then(unwrap), // {kmIn, routeNotes}
  sign: (id, body) => api.post(`/v1/test-drives/${id}/sign`, body).then(unwrap),     // {signatureDocumentId}

  /**
   * Check the customer in and put the car on the road, from a booked
   * appointment. (E13 / T000.)
   *
   * body: { appointmentId, kmOut, tradePlateId?, insuranceDeclared,
   *         licenceFrontId, licenceBackId?, licenceNumber?, licenceExpiry?,
   *         signatureId? | agreementHeld, documentIds? }
   *
   * This is the only path that creates a test-drive record from the diary. The
   * two booleans are a named consultant attesting that the paper agreement is
   * held and insurance was declared — the backend records who and when, and
   * refuses without them.
   */
  startFromAppointment: (body) =>
    api.post('/v1/test-drives/from-appointment', body).then(unwrap),

  /* ── check-in captures: licence, signature, documents ── */

  /**
   * Upload one capture. kind: LICENCE_FRONT | LICENCE_BACK | SIGNATURE (PNG) | DOCUMENT.
   * Pass appointmentId before the drive exists, testDriveId after.
   */
  uploadCapture: ({ file, kind, appointmentId, testDriveId, label, signerName, fileName }) => {
    const fd = new FormData();
    fd.append('file', file, fileName || file.name || `${kind.toLowerCase()}.bin`);
    fd.append('kind', kind);
    if (appointmentId) fd.append('appointmentId', appointmentId);
    if (testDriveId) fd.append('testDriveId', testDriveId);
    if (label) fd.append('label', label);
    if (signerName) fd.append('signerName', signerName);
    return api.post('/v1/test-drives/captures', fd, { timeout: 60_000 }).then(unwrap);
  },
  driveCaptures: (id) => api.get(`/v1/test-drives/${id}/captures`).then(unwrap),

  ocrLicence: (file) => {
    const fd = new FormData();
    fd.append('file', file, file.name || 'licence.jpg');
    return api.post('/v1/test-drives/licence-ocr', fd, { timeout: 25_000 }).then(unwrap);
  },
  /** Blob of a capture. Licence images 4xx for roles other than DP / SM. */
  captureBlob: (captureId) =>
    api.get(`/v1/test-drives/captures/${captureId}/content`, { responseType: 'blob' }).then((r) => r.data),

  /* ── trade plates ── */
  tradePlates: (params) => api.get('/v1/trade-plates', { params }).then(unwrap),
  createTradePlate: (body) => api.post('/v1/trade-plates', body).then(unwrap),
  updateTradePlate: (id, body) => api.patch(`/v1/trade-plates/${id}`, body).then(unwrap),
  deleteTradePlate: (id) => api.delete(`/v1/trade-plates/${id}`).then(unwrap),
};
